import React from 'react';
import { Field, useFormState } from 'react-final-form';
import { ThreeDots } from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';

import PasswordInput from '../../components/common-inputs/PasswordInput';
import CommonButton from '../../components/common-button/CommonButton';
import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';

import scss from './ConsumerLogin.module.scss';
import WithError from '../../components/with-error/WithError';

const ConsumerConfirmFormInner = ({ handleSubmit }) => {
  const { t } = useTranslation('consumer');
  const { submitting: isLoading } = useFormState();

  return (
    <form className={scss.form} onSubmit={handleSubmit}>
      <h1 className={scss.title}>{t('confirmation')}</h1>

      <div className={scss.items}>
        <h4 className={scss.subtitle}>{t('enterPasswordToGetAccessToProject')}</h4>

        <Field name='password'>
          {({ input, meta }) => (
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <PasswordInput
                tabIndex={'-1'}
                formProps={input}
                autoComplete='password'
                disabled={isLoading}
                isError={meta.touched && meta.error}
                LeftIcon={<Icon icon={ICONS.Lock} />}
              />
            </WithError>
          )}
        </Field>
      </div>

      <div className={scss.buttons}>
        <CommonButton styleColor='primary' type='submit' maxWidth={190} disabled={isLoading}>
          {isLoading ? <ThreeDots height={15} width={40} /> : null}
          {t('submit')}
        </CommonButton>
      </div>
    </form>
  );
};

export default ConsumerConfirmFormInner;
